export default __webpack_public_path__ + "static/media/Capaldo.299a5288.jpg";